import { useMemo } from 'react';
import { PaymentMethodListUIProps } from '../../../components/payment-methods/list/payment-method-list-ui';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { useProcessorDataContext } from '../../../contexts';
import { usePaymentMethodsJustifiContext } from '../context/payment-methods-justifi.context';
import { usePaymentMethodsStateContext } from '../context/payment-methods-state.context';
import { usePaymentMethodsStripeContext } from '../context/payment-methods-stripe.context';

export type PaymentMethodsContextToListProps = {
  stripeComponent: React.FC<PaymentMethodListUIProps>;
  justifiComponent: React.FC<PaymentMethodListUIProps>;
};
export const PaymentMethodsContextToList = ({
  stripeComponent: StripeComponent,
  justifiComponent: JustifiComponent,
}: PaymentMethodsContextToListProps) => {
  return (
    <GatewaySwitch
      stripeContent={StripeListWithContext}
      stripeProps={{ render: StripeComponent }}
      justifiContent={JustifiListWithContext}
      justifiProps={{ render: JustifiComponent }}
    />
  );
};

const StripeListWithContext = ({ render: RenderStripeComponent }: { render: React.FC<PaymentMethodListUIProps> }) => {
  const { selectedPaymentMethod, setSelectedPaymentMethod } = usePaymentMethodsStateContext();

  const {
    stripeData: { enableAddAchMethod },
  } = useProcessorDataContext();

  const {
    person,
    showAchList,
    minAchAmount,
    cardPaymentMethods,
    achPaymentMethods,
    shouldShowLoading,
    ConFirmDeleteModal,
    disableAchPaymentMethods,
    onClickAddAch,
    onClickAddCard,
    showConfirmDeletePaymentModal,
    onClickResendVerification,
    invalidatePaymentMethodsByPerson,
  } = usePaymentMethodsStripeContext();

  const cardProps = useMemo(() => {
    return {
      paymentMethods: cardPaymentMethods,
    };
  }, [cardPaymentMethods]);

  const achProps = useMemo(() => {
    return {
      paymentMethods: achPaymentMethods,
      minAchAmount,
      disableAchPaymentMethods,
      personId: person?.personId ?? '',
      onClickResendVerification,
      invalidatePaymentMethodsByPerson,
    };
  }, [
    achPaymentMethods,
    minAchAmount,
    disableAchPaymentMethods,
    person?.personId,
    onClickResendVerification,
    invalidatePaymentMethodsByPerson,
  ]);

  return (
    <>
      <RenderStripeComponent
        isLoading={shouldShowLoading}
        cardProps={cardProps}
        onSelectPaymentMethod={setSelectedPaymentMethod}
        onClickDelete={showConfirmDeletePaymentModal}
        selectedPaymentMethod={selectedPaymentMethod}
        showAchList={showAchList}
        addAchEnabled={enableAddAchMethod}
        onClickAddCard={onClickAddCard}
        onClickAddAch={onClickAddAch}
        achProps={achProps}
      />
      {ConFirmDeleteModal}
    </>
  );
};

const JustifiListWithContext = ({ render: RenderJustifiComponent }: { render: React.FC<PaymentMethodListUIProps> }) => {
  const { selectedPaymentMethod, setSelectedPaymentMethod } = usePaymentMethodsStateContext();

  const {
    stripeData: { enableAddAchMethod },
  } = useProcessorDataContext();

  const { paymentMethods, shouldShowLoading, onClickAddCard, showConfirmDeletePaymentModal, ConFirmDeleteModal } =
    usePaymentMethodsJustifiContext();

  const cardProps = useMemo(() => {
    return {
      paymentMethods,
    };
  }, [paymentMethods]);

  return (
    <>
      <RenderJustifiComponent
        isLoading={shouldShowLoading}
        cardProps={cardProps}
        onSelectPaymentMethod={setSelectedPaymentMethod}
        onClickDelete={showConfirmDeletePaymentModal}
        selectedPaymentMethod={selectedPaymentMethod}
        showAchList={false}
        addAchEnabled={enableAddAchMethod}
        onClickAddCard={onClickAddCard}
      />
      {ConFirmDeleteModal}
    </>
  );
};
